import Konva from 'konva';
import * as buttons from 'smg/buttons';
import { AddCartItemParamsUpload, AddCartItems } from 'smg/customer-api/v2/carts';
import { ShowError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import Modal from 'smg/modal';
import * as template from 'smg/template';
import * as uploads from 'smg/uploads';
import * as models from 'smg/customer-api/models';
import { Relref } from '../hugo';
import * as stockitems from '../stockitems';

void main();

async function main() {
    stockitems.InitGallery();
    stockitems.InitSeeMore();

    const $modalCanvasParent = template.Clone('#modal-canvas-parent-template').firstElementChild as HTMLElement;
    $modalCanvasParent.style.position = 'absolute';
    $modalCanvasParent.style.top = '-10000px';
    $modalCanvasParent.style.left = '-10000px';
    document.body.appendChild($modalCanvasParent);

    const $dropContainersParent = document.querySelector('#drop-containers-parent') as HTMLDivElement;

    $dropContainersParent.append(template.Clone('#drop-container-front-template'));
    $dropContainersParent.append(template.Clone('#drop-container-back-template'));

    const $form = document.querySelector('#stock-item-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    const $quantity = document.querySelector('#quantity') as HTMLInputElement;
    const $addToCart = document.querySelector('#add-to-cart') as HTMLButtonElement;
    const $personalize = document.querySelector('#personalize') as HTMLButtonElement;
    const $reopenEditor = document.querySelector('#reopen-editor-button-parent') as HTMLDivElement;

    const $modalDivider = document.querySelector('#modal-divider') as HTMLDivElement;

    const $canvasContainer = document.querySelector('#canvas-container') as HTMLDivElement;
    const $modalMainRow = document.querySelector('#modal-main-row') as HTMLDivElement;

    const $preview = document.querySelector('#preview-image-parent') as HTMLDivElement;

    const $fields = document.querySelector('#modal-right') as HTMLElement;
    const $frontInputs = document.querySelector('#front-inputs') as HTMLDivElement;
    const $backInputs = document.querySelector('#back-inputs') as HTMLDivElement;

    const $editorButtons = document.querySelector('#editor-buttons') as HTMLDivElement;

    const $navAlert = document.querySelector('#alert-nav-no-img') as HTMLDivElement;

    const $metaThemeColor = document.querySelector("meta[name='theme-color']") as HTMLMetaElement;
    const initialThemeColor = $metaThemeColor.content;

    let modalActive = false;
    let backFace = false;
    let frontUploaded = false;
    let backUploaded = false;

    let firstOpen = true;

    const $canvasParent = document.querySelector('#canvas-parent') as HTMLDivElement;

    const $canvasUploaderLabelFront = document.querySelector('#canvas-uploader-front') as HTMLLabelElement;
    const $canvasUploaderLabelBack = document.querySelector('#canvas-uploader-back') as HTMLLabelElement;

    document.querySelector('#close-alert-nav')?.addEventListener('click', () => $navAlert.classList.add('d-none'));
    $quantity.parentElement?.classList.add('d-none');
    $addToCart.classList.add('d-none');

    // Define an interface for "editor state" to hold all data needed to reset the editor.
    /**
     * Holds all the data needed to recreate a state of the modal editor.
    */
    interface editorState {
        frontUploaded: boolean;
        backUploaded: boolean;

        imageFront: {
            /** Image src blob URL */
            imageSrc: string;
            posX: number;
            posY: number;
            width: number;
            height: number;
            scaleX: number;
            scaleY: number;
            uploadID: number;
        };

        imageBack: {
            /** Image src blob URL */
            imageSrc: string;
            posX: number;
            posY: number;
            width: number;
            height: number;
            scaleX: number;
            scaleY: number;
            uploadID: number;
        };
    }

    const stage = new Konva.Stage({
        container: $canvasParent,
    });

    const bgImage = await new Promise<Konva.Image>(resolve => {
        const img = new Image();
        img.onload = () =>
            resolve(new Konva.Image({
                image: img,
                draggable: false,
                listening: false,
            }));
        img.src = `${Relref('/')}img/custom-bottle-openers/NEW-DT-BLANKS.png`;
    });

    const bgLayer = new Konva.Layer();
    bgLayer.id('bgLayer');
    stage.add(bgLayer);
    bgLayer.add(bgImage);

    let scale = 1;
    let offsetX = 0;
    let offsetY = 0;

    function fitStageIntoParentContainer(firstRun = true) {
        const $stageChildren: ChildNode[] = [];
        if (!firstRun) {
            $stageChildren.push(...Array.from($canvasContainer.childNodes));
            $canvasContainer.innerHTML = '';
        }

        if (modalActive) {
            stage.width($canvasContainer.offsetWidth * (3000 / 1500));
            stage.height(stage.width() * (1500 / 3000));
            scale = (($canvasContainer.offsetWidth * (3000 / 1500))) / bgImage.width();
        } else {
            stage.width(3000);
            stage.height(1500);
            scale = 1;
        }

        stage.scale({ x: scale, y: scale });

        if ($stageChildren) {
            for (const c of $stageChildren) {
                $canvasContainer.appendChild(c);
            }
        }

        offsetX = 0;
        offsetY = 0;

        if (modalActive) {
            if (backFace) {
                offsetX = 1500;
            }
        }

        stage.offsetX(offsetX);
        stage.offsetY(-offsetY);

        $canvasContainer.setAttribute('style', `--scale:${scale};--offsetY:${offsetY}px;--offsetX:${offsetX}px`);
    }

    const $stageLoader = document.querySelector('#stage-loader') as HTMLElement;

    const showLoading = () => {
        $canvasContainer.style.opacity = '0.5';
        $canvasContainer.style.pointerEvents = 'none';
        $stageLoader.classList.remove('d-none');
    };

    const hideLoading = () => {
        $canvasContainer.style.opacity = '';
        $canvasContainer.style.pointerEvents = '';
        $stageLoader.classList.add('d-none');
    };

    // start front uploader

    let frontUploadID = 0;
    const frontUploadLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        width: bgImage.width(),
        height: bgImage.height(),
        id: 'frontUploadLayer',
    });
    const frontUploadImage = new Konva.Image({
        image: new Image(),
        id: 'frontUploadImage',
    });
    stage.add(frontUploadLayer);

    frontUploadLayer.add(frontUploadImage);

    const frontUploadTransformerLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        visible: false,
        id: 'frontUploadTransformerLayer',
    });
    const frontUploaderTransformer = new Konva.Transformer({
        anchorStroke: '#fff',
        borderStroke: '#1a73e8',
        anchorSize: 9,
        anchorFill: '#1a73e8',
        centeredScaling: true,
    });
    frontUploadTransformerLayer.add(frontUploaderTransformer);
    stage.add(frontUploadTransformerLayer);

    const frontTransformerShape = new Konva.Rect({
        draggable: true,
    });
    frontUploadTransformerLayer.add(frontTransformerShape);
    frontUploaderTransformer.nodes([frontTransformerShape]);

    const $dropContainerFront = document.querySelector('#drop-container-front') as HTMLElement;
    const $stageUploadButtonFront = document.querySelector('#stage-upload-button-front') as HTMLButtonElement;
    $stageUploadButtonFront.addEventListener('click', () => $canvasUploaderLabelFront.click());

    const $resetFront = document.querySelector('#reset-front') as HTMLButtonElement;
    const $editFront = document.querySelector('#edit-front') as HTMLButtonElement;
    const $changeImageFront = document.querySelector('#change-image-front') as HTMLButtonElement;
    const $doneFront = document.querySelector('#done-front') as HTMLButtonElement;

    const startTransformModeFront = () => {
        $editorButtons.classList.remove('d-none');
        $editFront.classList.add('d-none');
        $resetFront.classList.remove('d-none');
        $changeImageFront.classList.remove('d-none');
        $doneFront.classList.remove('d-none');

        $dropContainersParent.classList.add('pe-none');

        frontUploadTransformerLayer.show();
    };

    const stopTransformModeFront = () => {
        $resetFront.classList.add('d-none');
        $changeImageFront.classList.add('d-none');
        $doneFront.classList.add('d-none');

        $dropContainersParent.classList.remove('pe-none');

        if (!backFace && frontUploaded) {
            $editFront.classList.remove('d-none');
        }

        frontUploadTransformerLayer.hide();
    };

    let setFrontImageSizeAndPosition: () => void;

    $resetFront.addEventListener('click', e => {
        e.preventDefault();
        setFrontImageSizeAndPosition?.();
    });

    $editFront.addEventListener('click', startTransformModeFront);
    $changeImageFront.addEventListener('click', () => $canvasUploaderLabelFront.click());
    $doneFront.addEventListener('click', stopTransformModeFront);

    let frontImg = new Image();
    let frontShape: Konva.Shape;

    const addImageFront = (blobURL: string) => {
        const maskActualWidth = 746;
        const maskActualHeight = 1374;
        const maskOffsetX = 400;
        const maskOffsetY = 50;
        frontImg = new Image();

        const mask = new Image();
        const promise = new Promise<void>(resolve => {
            if (blobURL === '') {
                if (frontShape) {
                    frontShape.destroy();
                }
                $dropContainerFront.classList.remove('d-none');
                resolve();
                return;
            }
            mask.onload = () => {
                frontImg.src = blobURL;
                frontImg.setAttribute('style', 'image-orientation:none');
                frontImg.onload = () => {
                    const originalRatios = {
                        width: maskActualWidth / frontImg.naturalWidth,
                        height: maskActualHeight / frontImg.naturalHeight,
                    };

                    // formula for cover:
                    const coverRatio = Math.max(originalRatios.width, originalRatios.height);

                    // result:
                    const newImageWidth = frontImg.naturalWidth * coverRatio;
                    const newImageHeight = frontImg.naturalHeight * coverRatio;

                    const newImageX = maskOffsetX - (newImageWidth - maskActualWidth) / 2;
                    const newImageY = maskOffsetY - (newImageHeight - maskActualHeight) / 2;

                    frontTransformerShape.setAttrs({
                        x: newImageX,
                        y: newImageY,
                        width: newImageWidth,
                        height: newImageHeight,
                        scaleX: 1,
                        scaleY: 1,
                    });
                    frontTransformerShape.draw();

                    if (frontShape) {
                        frontShape.destroy();
                    }

                    frontShape = new Konva.Shape({
                        sceneFunc: ctx => {
                            ctx.save();
                            ctx.drawImage(mask, -frontShape.x(), -frontShape.y(), mask.naturalWidth, mask.naturalHeight);
                            // TODO typescript version bug?
                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-in';

                            const toRadians = Math.PI / 180;
                            const angleInDeg = frontUploaderTransformer.rotation();
                            ctx.rotate(angleInDeg * toRadians);
                            ctx.drawImage(frontImg, 0, 0, frontUploaderTransformer.width() / stage.scaleX(), frontUploaderTransformer.height() / stage.scaleX());
                            ctx.rotate(-angleInDeg * toRadians);

                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-over';
                            ctx.restore();
                        },
                        hitFunc: ctx => {
                            ctx.rect(0, 0, frontUploaderTransformer.width() / stage.scaleX(), frontUploaderTransformer.height() / stage.scaleX());
                            ctx.fillStrokeShape(frontShape);
                        },
                    });
                    setFrontImageSizeAndPosition = () => {
                        frontTransformerShape.rotation(0);
                        frontShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        frontTransformerShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        frontTransformerShape.draw();
                    };
                    setFrontImageSizeAndPosition();
                    frontUploadLayer.add(frontShape);

                    frontTransformerShape.off('dragmove');
                    frontTransformerShape.on('dragmove', () => frontShape.position(frontTransformerShape.position()));

                    frontTransformerShape.off('transform');
                    frontTransformerShape.on('transform', () => frontShape.position(frontTransformerShape.position()));

                    frontShape.on('click', () => startTransformModeFront);

                    hideLoading();
                    resolve();
                };

                $dropContainerFront.classList.add('d-none');
                startTransformModeFront();

                $uploadRequired.forEach($el => $el.classList.add('d-none'));
            };
        });
        mask.src = `${Relref('/')}img/custom-bottle-openers/NEW-DT-MASK-L.png`;
        $canvasContainer.classList.remove('no-edit-btn');
        return promise;
    };

    new uploads.Uploader($canvasUploaderLabelFront, {
        dropZones: [$dropContainerFront],
        start: showLoading,
        stop: hideLoading,
        success: async (thumb, uploadID, blobURL) => {
            $navAlert.classList.add('d-none');
            frontUploadID = uploadID;
            frontUploaded = true;
            await addImageFront(blobURL);
        },
    });

    // stop front uploader

    // start back uploader

    let backUploadID = 0;
    const backUploadLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        width: bgImage.width(),
        height: bgImage.height(),
        id: 'backUploadLayer',
    });
    const backUploadImage = new Konva.Image({
        image: new Image(),
        id: 'backUploadImage',
    });
    stage.add(backUploadLayer);

    backUploadLayer.add(backUploadImage);

    const backUploadTransformerLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        visible: false,
        id: 'backUploadTransformerLayer',
    });
    const backUploaderTransformer = new Konva.Transformer({
        anchorStroke: '#fff',
        borderStroke: '#1a73e8',
        anchorSize: 9,
        anchorFill: '#1a73e8',
        centeredScaling: true,
    });
    backUploadTransformerLayer.add(backUploaderTransformer);
    stage.add(backUploadTransformerLayer);

    const backTransformerShape = new Konva.Rect({
        draggable: true,
    });
    backUploadTransformerLayer.add(backTransformerShape);
    backUploaderTransformer.nodes([backTransformerShape]);

    const $dropContainerBack = document.querySelector('#drop-container-back') as HTMLElement;
    const $stageUploadButtonBack = document.querySelector('#stage-upload-button-back') as HTMLButtonElement;
    $stageUploadButtonBack.addEventListener('click', () => $canvasUploaderLabelBack.click());

    const $resetBack = document.querySelector('#reset-back') as HTMLButtonElement;
    const $editBack = document.querySelector('#edit-back') as HTMLButtonElement;
    const $changeImageBack = document.querySelector('#change-image-back') as HTMLButtonElement;
    const $doneBack = document.querySelector('#done-back') as HTMLButtonElement;

    const startTransformModeBack = () => {
        $editorButtons.classList.remove('d-none');
        $editBack.classList.add('d-none');
        $resetBack.classList.remove('d-none');
        $changeImageBack.classList.remove('d-none');
        $doneBack.classList.remove('d-none');

        $dropContainersParent.classList.add('pe-none');

        backUploadTransformerLayer.show();
    };

    const stopTransformModeBack = () => {
        $resetBack.classList.add('d-none');
        $changeImageBack.classList.add('d-none');
        $doneBack.classList.add('d-none');

        $dropContainersParent.classList.remove('pe-none');

        if (backFace && backUploaded) {
            $editBack.classList.remove('d-none');
        }

        backUploadTransformerLayer.hide();
    };

    let setBackImageSizeAndPosition: () => void;

    $resetBack.addEventListener('click', e => {
        e.preventDefault();
        setBackImageSizeAndPosition?.();
    });

    $editBack.addEventListener('click', startTransformModeBack);
    $changeImageBack.addEventListener('click', () => $canvasUploaderLabelBack.click());
    $doneBack.addEventListener('click', stopTransformModeBack);

    let backImg = new Image();
    let backShape: Konva.Shape;

    const addImageBack = (blobURL: string) => {
        const maskActualWidth = 746;
        const maskActualHeight = 1374;
        const maskOffsetX = 1880;
        const maskOffsetY = 50;
        backImg = new Image();

        const mask = new Image();
        const promise = new Promise<void>(resolve => {
            if (blobURL === '') {
                if (backShape) {
                    backShape.destroy();
                }
                $dropContainerBack.classList.remove('d-none');
                resolve();
                return;
            }
            mask.onload = () => {
                backImg.onload = () => {
                    const originalRatios = {
                        width: maskActualWidth / backImg.naturalWidth,
                        height: maskActualHeight / backImg.naturalHeight,
                    };

                    // formula for cover:
                    const coverRatio = Math.max(originalRatios.width, originalRatios.height);

                    // result:
                    const newImageWidth = backImg.naturalWidth * coverRatio;
                    const newImageHeight = backImg.naturalHeight * coverRatio;

                    const newImageX = maskOffsetX - (newImageWidth - maskActualWidth) / 2;
                    const newImageY = maskOffsetY - (newImageHeight - maskActualHeight) / 2;

                    backTransformerShape.setAttrs({
                        x: newImageX,
                        y: newImageY,
                        width: newImageWidth,
                        height: newImageHeight,
                        scaleX: 1,
                        scaleY: 1,
                    });
                    backTransformerShape.draw();

                    if (backShape) {
                        backShape.destroy();
                    }
                    backShape = new Konva.Shape({
                        sceneFunc: ctx => {
                            ctx.save();
                            ctx.drawImage(mask, -backShape.x(), -backShape.y(), mask.naturalWidth, mask.naturalHeight);
                            // TODO typescript version bug?
                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-in';

                            const toRadians = Math.PI / 180;
                            const angleInDeg = backUploaderTransformer.rotation();
                            ctx.rotate(angleInDeg * toRadians);
                            ctx.drawImage(backImg, 0, 0, backUploaderTransformer.width() / stage.scaleX(), backUploaderTransformer.height() / stage.scaleX());
                            ctx.rotate(-angleInDeg * toRadians);

                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-over';
                            ctx.restore();
                        },
                        hitFunc: ctx => {
                            ctx.rect(0, 0, backUploaderTransformer.width() / stage.scaleX(), backUploaderTransformer.height() / stage.scaleX());
                            ctx.fillStrokeShape(backShape);
                        },
                    });
                    setBackImageSizeAndPosition = () => {
                        backTransformerShape.rotation(0);
                        backShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        backTransformerShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        backTransformerShape.draw();
                    };
                    setBackImageSizeAndPosition();
                    backUploadLayer.add(backShape);

                    backTransformerShape.off('dragmove');
                    backTransformerShape.on('dragmove', () => backShape.position(backTransformerShape.position()));

                    backTransformerShape.off('transform');
                    backTransformerShape.on('transform', () => backShape.position(backTransformerShape.position()));

                    backShape.on('click', () => startTransformModeBack);

                    hideLoading();
                    resolve();
                };
                backImg.src = blobURL;

                $dropContainerBack.classList.add('d-none');
                startTransformModeBack();

                $uploadRequired.forEach($el => $el.classList.add('d-none'));
            };
        });
        mask.src = `${Relref('/')}img/custom-bottle-openers/NEW-DT-MASK-R.png`;
        $canvasContainer.classList.remove('no-edit-btn');
        return promise;
    };

    new uploads.Uploader($canvasUploaderLabelBack, {
        dropZones: [$dropContainerBack],
        start: showLoading,
        stop: hideLoading,
        success: async (thumb, uploadID, blobURL) => {
            $navAlert.classList.add('d-none');
            backUploadID = uploadID;
            backUploaded = true;
            await addImageBack(blobURL);
        },
    });

    // stop back uploader

    // Disable hit graph for most Konva layers, should improve performance by disabling mouse event detection.
    bgLayer.hitGraphEnabled(false);

    let frontPreviewPageImgBlob: string;
    let backPreviewPageImgBlob: string;
    let frontPreviewImgBlob: string;

    function createCoinPreview() {
        $preview.innerHTML = '';
        $preview.append(template.Clone('#loading'));

        // crop and generate preview images
        scale = 1;
        const $frontPreviewPageImg = new Image();
        frontPreviewPageImgBlob = stage.toDataURL({
            quality: 1,
            mimeType: 'image/png',
            x: offsetX * scale,
            y: offsetY * scale,
            width: 1500 * scale,
            height: 1500 * scale,
        });
        $frontPreviewPageImg.src = frontPreviewPageImgBlob;

        frontPreviewImgBlob = stage.toDataURL({
            quality: 1,
            mimeType: 'image/png',
            x: 344 * scale,
            y: 26 * scale,
            width: 822 * scale,
            height: 1452 * scale,
        });
        $frontPreviewPageImg.src = frontPreviewPageImgBlob;

        const $backPreviewPageImg = new Image();
        backPreviewPageImgBlob = stage.toDataURL({
            quality: 1,
            mimeType: 'image/png',
            x: (offsetX + 1500 + 64) * scale,
            y: offsetY * scale,
            width: 1500 * scale,
            height: 1500 * scale,
        });
        $backPreviewPageImg.src = backPreviewPageImgBlob;

        $frontPreviewPageImg.setAttribute('id', 'front-preview-image');
        $backPreviewPageImg.setAttribute('id', 'back-preview-image');

        $preview.append($frontPreviewPageImg);
        $preview.append($backPreviewPageImg);

        $preview.querySelector('#preview-loading-icon')?.remove();
    }

    $canvasParent.firstElementChild?.setAttribute('id', 'editor');

    const $uploadRequired = document.querySelectorAll('.upload-required');

    document.addEventListener('click', e => {
        if (!frontUploadID && !backUploadID) {
            return;
        }

        if (e.target !== $canvasContainer &&
            e.target !== $editFront &&
            e.target !== $editBack &&
            e.target !== $dropContainersParent &&
            !(e.target instanceof HTMLElement && e.target?.closest('#canvas-container'))) {
            stopTransformModeFront();
            stopTransformModeBack();
        }
    });

    let prev: editorState = {
        // textFT: $frontTopText.value ?? '',
        // textFB: $frontBottomText.value ?? '',
        // textBT: $backTopText.value ?? '',
        // textBB: $backBottomText.value ?? '',
        // editedTextFT: editedTextFT,
        // editedTextFB: editedTextFB,
        // editedTextBT: editedTextBT,
        // editedTextBB: editedTextBB,
        frontUploaded: frontUploaded,
        backUploaded: backUploaded,
        imageFront: {
            imageSrc: '',
            posX: frontTransformerShape.x(),
            posY: frontTransformerShape.y(),
            width: frontTransformerShape.width(),
            height: frontTransformerShape.height(),
            scaleX: frontTransformerShape.scaleX(),
            scaleY: frontTransformerShape.scaleY(),
            uploadID: frontUploadID ?? 0,
        },
        imageBack: {
            imageSrc: '',
            posX: backTransformerShape.x(),
            posY: backTransformerShape.y(),
            width: backTransformerShape.width(),
            height: backTransformerShape.height(),
            scaleX: backTransformerShape.scaleX(),
            scaleY: backTransformerShape.scaleY(),
            uploadID: backUploadID ?? 0,
        },
    };

    function modalEditor() {
        $fields?.classList.remove('d-none');
        $editorButtons?.classList.remove('d-none');
        $modalDivider?.classList.add('d-lg-flex');
        $reopenEditor.classList.add('d-none');

        modalActive = true;
        const prevFirstOpen = firstOpen;

        prev = {
            frontUploaded: frontUploaded,
            backUploaded: backUploaded,
            imageFront: {
                imageSrc: '',
                posX: frontTransformerShape.x(),
                posY: frontTransformerShape.y(),
                width: frontTransformerShape.width(),
                height: frontTransformerShape.height(),
                scaleX: frontTransformerShape.scaleX(),
                scaleY: frontTransformerShape.scaleY(),
                uploadID: frontUploadID ?? 0,
            },
            imageBack: {
                imageSrc: '',
                posX: backTransformerShape.x(),
                posY: backTransformerShape.y(),
                width: backTransformerShape.width(),
                height: backTransformerShape.height(),
                scaleX: backTransformerShape.scaleX(),
                scaleY: backTransformerShape.scaleY(),
                uploadID: backUploadID ?? 0,
            },
        };

        prev.imageFront.imageSrc = frontImg.src;
        prev.imageBack.imageSrc = backImg.src;

        if (firstOpen) {
            void addImageFront('').then(stopTransformModeFront);
            void addImageBack('').then(stopTransformModeBack);
        }

        firstOpen = false;

        function modalToFront() {
            $modalToFrontSM.setAttribute('style', 'opacity:0');
            $modalToFrontSM.setAttribute('disabled', '');

            $navAlert.classList.add('d-none');
            backFace = false;

            stopTransformModeBack();

            modalTitle.textContent = 'Front of Bottle Opener';

            $frontInputs?.classList.remove('d-none');
            $backInputs?.classList.add('d-none');

            $editBack?.classList.add('d-none');
            $editFront?.classList.add('d-none');

            fitStageIntoParentContainer(false);

            $dropContainerBack?.classList.add('d-none');
            if (!frontUploaded) {
                $dropContainerFront?.classList.remove('d-none');
                $canvasContainer.classList.add('no-edit-btn');
                $editorButtons.classList.add('d-none');
            } else {
                $editorButtons.classList.remove('d-none');
                $editFront?.classList.remove('d-none');
                $canvasContainer.classList.remove('no-edit-btn');
            }
        }
        function modalToBack() {
            $modalToFrontSM.removeAttribute('style');
            $modalToFrontSM.removeAttribute('disabled');

            $navAlert.classList.add('d-none');
            backFace = true;

            stopTransformModeFront();

            modalTitle.textContent = 'Back of Bottle Opener';

            $frontInputs?.classList.add('d-none');
            $backInputs?.classList.remove('d-none');

            $editFront?.classList.add('d-none');
            $editBack?.classList.add('d-none');

            fitStageIntoParentContainer(false);

            $dropContainerFront?.classList.add('d-none');
            if (!backUploaded) {
                $dropContainerBack?.classList.remove('d-none');
                $canvasContainer.classList.add('no-edit-btn');
                $editorButtons.classList.add('d-none');
            } else {
                $editorButtons.classList.remove('d-none');
                $editBack?.classList.remove('d-none');
                $canvasContainer.classList.remove('no-edit-btn');
            }
        }

        const modalBtnToFront = () => {
            activeModal.$element.querySelector('.btn-modal-to-back')?.classList.remove('d-none');
            activeModal.$element.querySelector('.btn-modal-to-front')?.classList.add('d-none');
            activeModal.$element.querySelector('.btn-modal-complete')?.classList.add('d-none');
            modalToFront();
        };

        const modalBtnToBack = () => {
            if (!frontUploadID) {
                $navAlert.classList.remove('d-none');
                return;
            }
            activeModal.$element.querySelector('.btn-modal-to-back')?.classList.add('d-none');
            activeModal.$element.querySelector('.btn-modal-to-front')?.classList.remove('d-none');
            activeModal.$element.querySelector('.btn-modal-complete')?.classList.remove('d-none');
            modalToBack();
        };

        if (!frontUploaded) {
            $dropContainerFront?.classList.remove('d-none');
        }

        $dropContainerBack?.classList.remove('d-none');

        for (const $el of Array.from($uploadRequired)) {
            $el.classList.add('d-none');
        }

        $modalMainRow.classList.remove('d-none');
        $preview?.classList.add('d-none');

        $modalCanvasParent.removeAttribute('style');

        const exitModal = async (cancel?: boolean) => {
            stopTransformModeFront();
            stopTransformModeBack();

            $metaThemeColor.content = initialThemeColor;

            $editFront?.classList.add('d-none');
            $editBack?.classList.add('d-none');

            $fields?.classList.add('d-none');
            $editorButtons?.classList.add('d-none');
            $dropContainerFront?.classList.add('d-none');
            $dropContainerBack?.classList.add('d-none');
            $modalDivider?.classList.remove('d-lg-flex');

            modalActive = false;

            $modalCanvasParent.style.position = 'absolute';
            $modalCanvasParent.style.top = '-10000px';
            $modalCanvasParent.style.left = '-10000px';

            fitStageIntoParentContainer(false);

            $preview?.classList.remove('d-none');

            if (cancel) {
                await resetToPrev().then(() => {
                    createCoinPreview();
                    firstOpen = prevFirstOpen;
                });
            } else {
                createCoinPreview();
                firstOpen = false;
            }

            if (!firstOpen) {
                $personalize.classList.add('d-none');
                $addToCart.classList.remove('d-none');
                $quantity.parentElement?.classList.remove('d-none');
                $reopenEditor.classList.remove('d-none');
            }

            $modalMainRow.classList.add('d-none');
            activeModal.close();
        };

        async function resetToPrev() {
            // Reset front image
            if (prevFirstOpen) {
                await addImageFront('').then(stopTransformModeFront);
                await addImageBack('').then(stopTransformModeBack);
            } else {
                await addImageFront(prev.imageFront.imageSrc).then(() => {
                    stopTransformModeFront();
                    if (frontShape) {
                        frontShape.setAttrs({
                            x: prev.imageFront.posX,
                            y: prev.imageFront.posY,
                        });
                        frontTransformerShape.setAttrs({
                            x: prev.imageFront.posX,
                            y: prev.imageFront.posY,
                            width: prev.imageFront.width,
                            height: prev.imageFront.height,
                            scaleX: prev.imageFront.scaleX,
                            scaleY: prev.imageFront.scaleY,
                        });
                    }
                }).catch();
                frontUploaded = prev.frontUploaded;

                // Reset back image
                await addImageBack(prev.imageBack.imageSrc).then(() => {
                    stopTransformModeBack();
                    if (backShape) {
                        backShape.setAttrs({
                            x: prev.imageBack.posX,
                            y: prev.imageBack.posY,
                        });
                        backTransformerShape.setAttrs({
                            x: prev.imageBack.posX,
                            y: prev.imageBack.posY,
                            width: prev.imageBack.width,
                            height: prev.imageBack.height,
                            scaleX: prev.imageBack.scaleX,
                            scaleY: prev.imageBack.scaleY,
                        });
                    }
                }).catch();
                backUploaded = prev.backUploaded;
            }

            // Reset upload IDs
            frontUploadID = prev.imageFront.uploadID;
            backUploadID = prev.imageBack.uploadID;

            // Should now be fully reset
        }

        $metaThemeColor.content = '#ffffff';

        const activeModal = new Modal({
            title: 'Front of Bottle Opener',
            size: 'modal-sm',
            body: $modalCanvasParent,
            outsideClosable: false,
            submitAutoFocus: false,
            buttons: [
                {
                    text: 'Complete Bottle Opener Design',
                    class: 'btn btn-secondary text-white btn-modal-complete d-none',
                    click: async () => {
                        if (!frontUploadID || !backUploadID) {
                            $navAlert.classList.remove('d-none');
                            return;
                        } else {
                            await exitModal(false);
                        }
                    },
                },
                {
                    text: 'Edit Back of Bottle Opener >',
                    class: 'btn btn-secondary text-white btn-modal-to-back',
                    click: modalBtnToBack,
                },
                {
                    text: '< Edit Front of Bottle Opener',
                    class: 'btn btn-outline-secondary btn-modal-to-front d-none',
                    click: modalBtnToFront,
                },
            ],
            onClose: () => exitModal(true),
        });

        // The button constructor in the modal was treating the FontAwesome tags as literal,
        // so this is just resetting it to get it to show correctly.
        // The buttons have plain text carets < and > as placeholders by default, before this runs.

        const buttonToBack = activeModal.$element.querySelector('.btn-modal-to-back') as HTMLButtonElement;
        buttonToBack.innerHTML = 'Edit Back of Bottle Opener <i class="fas fa-chevron-right"></i>';

        const buttonToFront = activeModal.$element.querySelector('.btn-modal-to-front') as HTMLButtonElement;
        buttonToFront.innerHTML = '<i class="fas fa-chevron-left"></i> Front of Bottle Opener';

        // Remove the modal confirm button so we can use ours that checks for uploads before closing
        activeModal.$element.querySelector('#modal-confirm-btn')?.remove();
        activeModal.$element.querySelector('.btn-modal-complete')?.classList.add('d-none');

        const $modalHeader = activeModal.$element.querySelector('.modal-header') as HTMLDivElement;
        $modalHeader.prepend(template.Clone('#modal-sm-back-button'));
        const $modalToFrontSM = document.querySelector('.btn-back') as HTMLButtonElement;

        $modalToFrontSM.addEventListener('click', modalBtnToFront);

        const modalTitle = activeModal.$element.querySelector('.modal-title') as HTMLHeadingElement;

        modalToFront();
    }

    $personalize.addEventListener('click', e => {
        e.preventDefault();
        modalEditor();
    });

    function initPreview() {
        $modalMainRow.classList.remove('d-none');
        $preview?.classList.add('d-none');
        createCoinPreview();
        $modalMainRow.classList.add('d-none');
        $preview?.classList.remove('d-none');
    }

    $reopenEditor.addEventListener('click', e => {
        e.preventDefault();
        modalEditor();
    });

    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();

        if (!frontUploadID || !backUploadID) {
            for (const $el of Array.from($uploadRequired)) {
                $el.classList.remove('d-none');
            }
            return;
        }

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.disabled = true;
        buttons.Start($addToCart);

        bgLayer.hide();

        const frontURL = stage.toDataURL({
            quality: 1,
            mimeType: 'image/png',
            x: 378,
            y: 64,
            width: 746,
            height: 1374,
            pixelRatio: 1200 / (824 * scale),
        });

        const backURL = stage.toDataURL({
            quality: 1,
            mimeType: 'image/png',
            x: 1879,
            y: 64,
            width: 746,
            height: 1374,
            pixelRatio: 1200 / (824 * scale),
        });

        bgLayer.show();

        const previewUpload = await uploads.NewFromURL([{
            name: 'preview',
            mime: 'image/png',
            url: frontPreviewImgBlob,
        }]);

        const stageUploads = await uploads.NewFromURL([
            {
                name: '.front.jpg',
                mime: 'image/jpeg',
                url: await stockitems.ColorLayer(frontURL),
            },
            {
                name: '.front-white.jpg',
                mime: 'image/jpeg',
                url: await stockitems.WhiteLayer(frontURL),
            },
            {
                name: '.back.jpg',
                mime: 'image/jpeg',
                url: await stockitems.ColorLayer(backURL),
            },
            {
                name: '.back-white.jpg',
                mime: 'image/jpeg',
                url: await stockitems.WhiteLayer(backURL),
            },
        ]);

        const params: AddCartItemParamsUpload = {
            uploadID: previewUpload[0].uploadID,
            quantity: parseInt($quantity.value, 10),
            cartItemUploadIDs: [frontUploadID, backUploadID, ...stageUploads.map(u => u.uploadID)],
            uploadLineItem: {
                name: 'Custom Challenge Coins',
                lineItem: 'challenge coins',
                type: 'Made in USA - Simulated Enamel Coin',
                size: '1.27" × 2.25" Signature: Dog Tag Bottle Opener',
                networkSKUID: models.NetworkSKUID.NETWORK_SK_US_CUSTOM_BOTTLE_OPENERS,
                childLineItems: [
                    {
                        child: 'plating',
                        option: 'antique brass',
                    },
                    {
                        child: 'edge',
                        option: 'standard',
                    },
                ],
            },
        };

        AddCartItems(params).then(() => {
            window.location.href = Relref('/cart');
        }).catch(err => {
            $fieldset.disabled = false;
            buttons.Stop($addToCart);
            ShowError(err);
        });
    });

    fitStageIntoParentContainer();
    window.addEventListener('resize', () => fitStageIntoParentContainer(false));

    initPreview();
    $preview.querySelector('#preview-loading-icon')?.remove();
}